import { Box, useMediaQuery } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import ConfirmedTable from './ConfirmedTable'
import ReqSendTable from './ReqSendTable'
import FavoritesTable from './FavoritesTable'
import styles from './index.module.scss'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

export const VendorTrackerTab = ({ onRemove }) => {
	const [searchParams, setSearchParams] = useSearchParams()
	const tab = searchParams.get('tab')
	const [value, setValue] = useState(0)
	const isSmallScreen = useMediaQuery('(max-width:991px)')

	const proposals = useSelector((state) => state.proposal.proposals)
	const favoriteVendors = useSelector(
		(state) => state.kazooEvent.favoriteVendors
	)
	useEffect(() => {
		if(tab) setValue(1)
	},[tab])
	const reqSendTableData = useMemo(() => {
		if (!proposals?.length) return []
		return proposals
	}, [proposals])

	const favoriteVendorsData = useMemo(() => {
		if (!favoriteVendors?.length) return []
		return favoriteVendors
	}, [favoriteVendors])
	const handleChange = (event, newValue) => {
		setValue(newValue)
		if(!!tab) setSearchParams("")
	}
	function CustomTabPanel(props) {
		const { children, value, index, ...other } = props

		return (
			<div
				role="tabpanel"
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{value === index && <Box>{children}</Box>}
			</div>
		)
	}

	const mainTabStyle = {
		'& .MuiTabs-scrollButtons.Mui-disabled': {
			opacity: '0.3',
		},
		'&.MuiTabs-root': {
			minHeight: 'unset',
		},
		'& .MuiButtonBase-root': {
			padding: '11px 16px',
			minHeight: 'unset',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#313131',
			textTransform: 'capitalize',
			'&.Mui-selected': {
				color: '#7CA6BD',

				'& svg path': {
					stroke: '#7CA6BD',
				},
			},
		},
		'& .MuiTabs-indicator': {
			backgroundColor: '#7CA6BD',
		},
		'@media (max-width: 599px)': {
			'& .MuiButtonBase-root': {
				padding: '8px',
			},
		},
	}

	return (
		<>
			<div className={styles.tabSection}>
				<Box sx={{ width: '100%' }} className={styles.tabs}>
					<Box sx={{ borderBottom: 1, borderColor: '#DFE4EB' }}>
						<Tabs
							value={value}
							onChange={handleChange}
							aria-label="basic tabs example"
							sx={mainTabStyle}
							variant={isSmallScreen ? 'scrollable' : 'standard'}
							scrollButtons={isSmallScreen ? 'auto' : false}
							allowScrollButtonsMobile={isSmallScreen}
						>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="Confirmed">
											Confirmed
										</span>
									</div>
								}
							/>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="Vendor proposals">
											Vendor proposals
										</span>
									</div>
								}
							/>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="Favorites">
											Favorites
										</span>
									</div>
								}
							/>
						</Tabs>
					</Box>

					<div className={styles.tabContentWrp}>
						<CustomTabPanel
							value={value}
							index={0}
							className={styles.content}
						>
							<ConfirmedTable data={reqSendTableData} />
						</CustomTabPanel>
						<CustomTabPanel
							value={value}
							index={1}
							className={styles.content}
						>
							<ReqSendTable rows={reqSendTableData} />
						</CustomTabPanel>
						<CustomTabPanel
							value={value}
							index={2}
							className={styles.content}
						>
							<FavoritesTable rows={favoriteVendorsData} />
						</CustomTabPanel>
					</div>
				</Box>
			</div>
		</>
	)
}
